import { put, call, takeEvery } from 'redux-saga/effects'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import {
  SIGNUP_USER,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAILED,
  SIGNIN_USER,
  USER_SIGNIN_SUCCESS,
  USER_SIGNIN_FAILED,
  PASSWORD_CHANGE,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_FAILED,
  SIGNOUT_USER,
  USER_SIGNOUT_SUCCESS,
  USER_SIGNOUT_FAILED,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  USER_SERVER_DOWN,
} from '../../Constants/ActionTypes'
import service from '../../utils/service'
import {
  setToken,
  setAccountId,
  getAccountId,
  setSessionToken,
} from '../../utils/helper'
import _ from 'lodash'
import { removeLocalStorage, removeSessionStorage } from '../../utils/localStorage'
import axios from 'axios'

const signUpWithDetailsRequest = async (payload) =>
  await service
    .post(
      Urls.getApiUrl(`admin/signup/`, MICROSERVICES.SESSIONMANAGER),
      payload,
    )
    .then((authUser) => authUser)
    .catch((error) => error)

const signInWithDetailsRequest = async (payload, captcha) =>
  await axios
    .post(
      Urls.getApiUrl(`admin/signin/`, MICROSERVICES.SESSIONMANAGER),
      payload,
      { headers: { ...(captcha && captcha.value ? { 'g-recaptcha-response': captcha.value } : {}) } }
    )
    .then((authUser) => authUser)
    .catch((error) => {
      return error
    })

const signOutCurrentUserRequest = async (payload) =>
  await service.post(Urls.getApiUrl(`admin/${getAccountId()}/user/signout`, MICROSERVICES.SESSIONMANAGER), { email: payload.email })
    .then(logOutData => logOutData)
    .catch(error => error)

const changeUserPasswordRequest = async (payload) =>
  await service.post(Urls.getApiUrl(`admin/${getAccountId()}/user/resetPassword`, MICROSERVICES.SESSIONMANAGER), payload)
    .then(authUser => authUser)
    .catch(error => error)

const getCurrentUserRequest = async () =>
  await service
    .get(
      Urls.getApiUrl(
        `admin/signup/token/userdetails`,
        MICROSERVICES.SESSIONMANAGER,
      ),
    )
    .then((currentUserData) => currentUserData)
    .catch((error) => error)

function* signUpUserWithDetails({ payload }) {
  try {
    const response = yield call(signUpWithDetailsRequest, payload)
    const { status } = response
    if (status === 200) {
      yield put({ type: USER_SIGNUP_SUCCESS })
    } else {
      yield put({ type: USER_SIGNUP_FAILED, message: _.get(response, 'data.error.displayMessage', 'Something went wrong') })
    }
  } catch (error) {
    yield put({ type: USER_SIGNUP_FAILED, message: 'Something went wrong' })
  }
}

function* signInUserWithDetails({ payload }) {
  try {
    const response = yield call(signInWithDetailsRequest, {
      name: payload.userEmailId,
      password: payload.password,
    }, {
      value: payload.captchaValue
    })
    const { status, data, response: errorResponse } = response
    if (status === 200) {
      if (payload.remember) {
        setToken(data['GS-Authorization'])
      } else {
        setSessionToken(data['GS-Authorization'])
      }
      setAccountId(data['account_id'])
      yield put({ type: USER_SIGNIN_SUCCESS, payload: data })
    }
    else if (errorResponse.status >= 500) {
      yield put({ type: USER_SERVER_DOWN })
    }
    else {
      yield put({ type: USER_SIGNIN_FAILED, payload: errorResponse.data })
    }
  } catch (error) {
    yield put({ type: USER_SIGNIN_FAILED })
  }
}

function* signOutCurrentUser({ payload }) {
  try {
    const response = yield call(signOutCurrentUserRequest, { account_id: payload.account_id, email: payload.id })
    const { status, data } = response
    if (status === 200) {
      removeLocalStorage('auth')
      removeSessionStorage('auth')
      removeLocalStorage('account_id')
      yield put({ type: USER_SIGNOUT_SUCCESS })
    } else {
      yield put({ type: USER_SIGNOUT_FAILED })
    }
  } catch (error) {
    // setToken('')
    // setAccountId('')
    yield put({ type: USER_SIGNOUT_FAILED })
  }
}

function* changeUserPassword({ payload }) {
  try {
    const response = yield call(changeUserPasswordRequest, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({
        type: PASSWORD_CHANGE_SUCCESS,
        payload: 'Password changed successfully',
      })
    } else {
      yield put({
        type: PASSWORD_CHANGE_FAILED,
        payload: _.get(response, 'data.error.displayMessage', 'Failed to change password'),
      })
    }
  } catch (error) {
    yield put({
      type: PASSWORD_CHANGE_FAILED,
      payload: 'Failed to change password',
    })
  }
}

function* getCurrentUserWithToken({ payload }) {
  const token = payload
  try {
    const response = yield call(getCurrentUserRequest, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({ type: GET_CURRENT_USER_SUCCESS, payload: data.data })
    } else {
    }
  } catch (error) {
    console.debug(error)
  }
}

export function* signUpWithDetails() {
  yield takeEvery(SIGNUP_USER, signUpUserWithDetails)
}

export function* signInWithDetails() {
  yield takeEvery(SIGNIN_USER, signInUserWithDetails)
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOutCurrentUser)
}

export function* passwordChange() {
  yield takeEvery(PASSWORD_CHANGE, changeUserPassword)
}

export function* getCurrentUser() {
  yield takeEvery(GET_CURRENT_USER, getCurrentUserWithToken)
}
